import LoadingProgress from './LoadingProgress'

export default LoadingProgress
